import { ESTATE_TAX_RATE_FRIENDLY } from '@/modules/entities/entities.constants';

export const IMPLIED_TAX_HELP_COPY = `Implied estate tax savings assumes assets would otherwise be taxable at a ${ESTATE_TAX_RATE_FRIENDLY} federal estate tax rate. Does not account for state transfer taxes.`;
